import {
  AtividadeColetivaGrupoCabecalho,
  AtividadeColetivaGrupoItemModel,
  AtividadeColetivaGrupoSelectItemModel,
  AtividadeColetivaGrupoSemResultados,
} from './model-atividadeColetivaGrupoSelectField'

export function isAtividadeColetivaGrupoItemModel(
  item: AtividadeColetivaGrupoSelectItemModel
): item is AtividadeColetivaGrupoItemModel {
  return (
    typeof item === 'object' &&
    item !== null &&
    'id' in item &&
    'nome' in item &&
    'equipesEnvolvidas' in item &&
    'unidadeDeSaude' in item
  )
}

export function isTipoGrupoVazio(
  item: AtividadeColetivaGrupoSelectItemModel
): item is AtividadeColetivaGrupoSemResultados {
  return item === AtividadeColetivaGrupoSemResultados.SEM_RESULTADOS_ENCONTRADOS
}

export function isTipoGrupoCabecalho(
  item: AtividadeColetivaGrupoSelectItemModel
): item is AtividadeColetivaGrupoCabecalho {
  return item === AtividadeColetivaGrupoCabecalho.MEUS_GRUPOS || item === AtividadeColetivaGrupoCabecalho.OUTROS_GRUPOS
}
